import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[1001] flex items-center justify-center p-4"
}
const _hoisted_2 = { class: "relative bg-white/95 backdrop-blur-md rounded-xl p-8 w-full max-w-md border border-blue-100 shadow-lg shadow-blue-500/10 z-[1002]" }
const _hoisted_3 = { class: "text-center mb-8" }
const _hoisted_4 = { class: "text-2xl font-bold bg-gradient-to-r from-blue-500 to-indigo-500 bg-clip-text text-transparent" }
const _hoisted_5 = { class: "text-gray-600 mt-2" }
const _hoisted_6 = { class: "text-gray-500 text-sm mt-3" }
const _hoisted_7 = { class: "space-y-4" }
const _hoisted_8 = ["disabled", "onClick"]
const _hoisted_9 = {
  key: 0,
  class: "fas fa-spinner fa-spin mr-3 text-xl text-blue-500"
}
const _hoisted_10 = {
  key: 0,
  class: "bg-red-50 text-red-600 px-4 py-4 rounded-lg mt-6 text-center border border-red-200 shadow-sm flex items-center"
}

import { ref, computed } from 'vue';
import { AuthApi, GetLoginUrlRequest, UserProviderMap } from '@/api/auth';
import { useI18nMessages } from '@/i18n';

// 组件 props

export default /*@__PURE__*/_defineComponent({
  __name: 'LoginModal',
  props: {
  modelValue: {
    type: Boolean,
    required: true
  },
  redirect: {
    type: String,
    default: ''
  }
},
  emits: ['update:modelValue', 'loginSuccess'],
  setup(__props, { emit: __emit }) {

const props = __props;

// 组件事件
const emit = __emit;

// 获取登录相关的国际化消息
const loginMsg = useI18nMessages('Login');

// 状态
const loading = ref(false);
const error = ref('');
const currentProvider = ref<number | null>(null);


// 检查UserProviderMap是否正确导入
if (!UserProviderMap) {
  error.value = loginMsg.value?.error?.serverError;
}

const loginTypes = computed(() => {
  const messages = loginMsg.value;
  
  // 如果UserProviderMap未定义，返回空数组
  if (!UserProviderMap) {
    return [];
  }
  
  return [
    {
      id: messages?.types?.[0]?.id,
      provider: messages?.types?.[0]?.provider,
      icon: messages?.types?.[0]?.icon,
      desc: messages?.types?.[0]?.desc,
      providerMap: UserProviderMap?.github, // 添加空值检查和回退值
    },
    {
      id: messages?.types?.[1]?.id,
      provider: messages?.types?.[1]?.provider,
      icon: messages?.types?.[1]?.icon,
      desc: messages?.types?.[1]?.desc,
      providerMap: UserProviderMap?.google, // 添加空值检查和回退值
    },
  ];
});

const handleSocialLogin = async (providerMap: number) => {
  if (loading.value) return;
  loading.value = true;
  error.value = '';
  currentProvider.value = providerMap;
  try {    
    const request: GetLoginUrlRequest = {
      provider: providerMap,
    };
    const response = await AuthApi.getLoginUrl(request);
    if (response.code === 0 && response.data.url) {
      // 根据URL是否包含查询参数选择正确的拼接方式
      const loginUrlWithState = response.data.url.includes('?')
        ? `${response.data.url}&state=${response.data.state}`
        : `${response.data.url}?state=${response.data.state}`;
      window.location.href = loginUrlWithState;
    } else {
      error.value = loginMsg.value?.error?.serverError;
      // 服务器错误也延迟关闭loading状态，确保错误信息可见
      setTimeout(() => {
        loading.value = false;
      }, 3000);
      return;
    }
  } catch (err: any) {
    error.value = loginMsg.value?.error?.networkError;
    setTimeout(() => {
      loading.value = false;
    }, 3000); // 延长到8秒，给用户足够时间看到错误信息
    return; // 防止执行finally中的代码
  } finally {
    if (!error.value) { // 只有在没有错误时才立即关闭加载状态
      loading.value = false;
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "transition-opacity duration-300",
    "enter-from-class": "opacity-0",
    "enter-to-class": "opacity-100",
    "leave-active-class": "transition-opacity duration-300",
    "leave-from-class": "opacity-100",
    "leave-to-class": "opacity-0"
  }, {
    default: _withCtx(() => [
      (__props.modelValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "absolute inset-0 bg-black/60 backdrop-blur-sm",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("button", {
                class: "absolute top-4 right-4 text-gray-600 hover:text-blue-600 transition-colors duration-200",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
              }, _cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
              ])),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(loginMsg).title), 1),
                _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(loginMsg).subtitle), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(loginMsg).memberTip), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(loginTypes.value, (loginType) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: loginType.id,
                    class: _normalizeClass(["w-full py-3 px-4 flex items-center justify-center rounded-lg border transition-all duration-200", {
              'opacity-60 cursor-not-allowed border-gray-200 bg-gray-100': loading.value,
              'border-gray-200 hover:border-blue-400 hover:bg-gray-50 text-gray-700 hover:text-blue-600': !loading.value
            }]),
                    disabled: loading.value,
                    onClick: ($event: any) => (handleSocialLogin(loginType.providerMap))
                  }, [
                    (loading.value && currentProvider.value === loginType.providerMap)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                      : (_openBlock(), _createElementBlock("i", {
                          key: 1,
                          class: _normalizeClass([loginType.icon, 'text-xl mr-3', loading.value ? 'text-gray-400' : ''])
                        }, null, 2)),
                    _createElementVNode("span", {
                      class: _normalizeClass({ 'text-gray-400': loading.value })
                    }, _toDisplayString(loginType.desc), 3)
                  ], 10, _hoisted_8))
                }), 128))
              ]),
              _createVNode(_Transition, {
                "enter-active-class": "transition-all duration-300",
                "enter-from-class": "opacity-0 transform -translate-y-4",
                "enter-to-class": "opacity-100 transform translate-y-0",
                "leave-active-class": "transition-all duration-300",
                "leave-from-class": "opacity-100",
                "leave-to-class": "opacity-0"
              }, {
                default: _withCtx(() => [
                  (error.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-exclamation-circle text-xl mr-2 text-red-500 flex-shrink-0" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(error.value), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})